import { get } from "lodash";
import ContentfulCategory from "models/data/contentful/ContentfulCategory";
import ContentfulToApiCategory from "models/data/mappings/ContentfulToApiCategory";

class ApiCategory {
  static default = {
    id: "",
    name: "",
    slug: "",
    descriptionHtml: "",
    longDescriptionHtml: "",
    title: "",
    metaDescription: ""
  };

  static id = (apiCategory: ApiCategory): string =>
    get(apiCategory, "id", ApiCategory.default.id);

  static slug = (apiCategory: ApiCategory): string =>
    get(apiCategory, "slug", ApiCategory.default.slug);

  static categoryName = (apiCategory: ApiCategory): string =>
    get(apiCategory, "name", ApiCategory.default.name);

  static descriptionHtml = (apiCategory: ApiCategory): string =>
    get(apiCategory, "descriptionHtml", ApiCategory.default.descriptionHtml);

  static longDescriptionHtml = (apiCategory: ApiCategory): string =>
    get(
      apiCategory,
      "longDescriptionHtml",
      ApiCategory.default.longDescriptionHtml
    );

  static title = (apiCategory: ApiCategory): string => 
    get(apiCategory, "title", ApiCategory.default.title);
  
  static metaDescription = (apiCategory: ApiCategory): string => 
    get(apiCategory, "metaDescription", ApiCategory.default.metaDescription);

  static async fetchWithId(id) {
    const contentfulCategory = await ContentfulCategory.fetchWithId(id);
    return ContentfulToApiCategory.map(contentfulCategory);
  }

  static async fetchWithSlug(slug) {
    const contentfulCategory = await ContentfulCategory.fetchWithSlug(slug);
    return ContentfulToApiCategory.map(contentfulCategory);
  }
}

export default ApiCategory;
